import logo from './logo.svg';
import './App.css';
import Home from './components/Home';
import CookComponent from './components/Cook';
import BabyCareComponent from './components/BabycareComponent';
import PatientCare from './components/PatientCareComponent';
import MaidComponent from './components/MaidComponent';
import About from './components/About';
import Contact from './components/Contact';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import ScrollToTop from './components/scroll';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/cook" element={<CookComponent />} />
          <Route path="/services/baby-care-taker" element={<BabyCareComponent />} />
          <Route path="/services/patient-care" element={<PatientCare />} />
          <Route path="/services/maid" element={<MaidComponent />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/about-us" element={<About />} />
         
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
